module.exports = __webpack_public_path__ + "img/ftm-bronze.41c3bd87.png";